import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { Masquerade, masqueradeToken } from 'go-modules/masquerade/masquerade.service';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { BehaviorSubject } from 'rxjs';
import { UserService as NgxUserService } from '@go-modules/services/user/user.service';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@go-modules/interfaces/user';
import { GoModalService } from '@go-modules/services/go-modal/go-modal.service';
import { EditUserDialogComponent } from '../edit-user/edit-user-dialog.component';

@Component({
	selector: 'user-search-dialog',
	templateUrl: './user-search-dialog.component.html',
	styleUrls: ['./user-search-dialog.component.scss'],
	standalone: false
})
export class UserSearchDialogComponent implements OnInit {
	public loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);
	public users$: BehaviorSubject<User[]> = new BehaviorSubject([]);
	public searchForm: UntypedFormGroup;
	public searchQuery: UntypedFormControl = new UntypedFormControl('', [Validators.required, Validators.minLength(3)]);

	constructor (
		public dialogRef: GoDialogRef,
		public ngxUserService: NgxUserService,
		private dialog: MatDialog,
		private translate: TranslateService,
		private fb: UntypedFormBuilder,
		private cdr: ChangeDetectorRef,
		private elementRef: ElementRef,
		private modal: GoModalService,
		@Inject(GO_MODAL_DATA) public data: {
			initialQuery: string;
		},
		@Inject(masqueradeToken) private masquerade: Masquerade,
		@Inject(userServiceToken) private userService: UserService
	) {
		this.searchForm = this.fb.group({
			searchQuery: this.searchQuery
		});
	}

	public ngOnInit () {
		this.searchForm.controls.searchQuery.setValue(this.data.initialQuery);
		this.getUsersBy(this.data.initialQuery);
	}

	public getUsersBy (query: string) {
		if (this.searchForm.invalid) {
			return;
		}
		this.users$.next([]);
		this.loading$.next(true);
		this.cdr.detectChanges();
		this.ngxUserService.search(query).subscribe((res) => {
			this.users$.next(res);
			this.loading$.next(false);
			this.cdr.detectChanges();
		});
	}

	public close () {
		this.dialogRef.close();
	}

	public clearSearch () {
		this.searchForm.reset();
		this.cdr.detectChanges();
		this.elementRef.nativeElement.querySelector('input.search-input').focus();
	}

	public openEditUser (user) {
		this.modal.open(EditUserDialogComponent, false, {
			data: {
				user
			}
		}).afterClosed().subscribe(({shouldClose}) => {
			if (shouldClose) {
				this.dialogRef.close();
			}
		});
	}

	public maskAs (user) {
		return this.masquerade.as(user).catch(() => {
			this.dialog.open(MessageDialogComponent, {
				data: {
					title: this.translate.instant('mask-user-error_title'),
					message: this.translate.instant('mask-user-error_message')
				}
			});
		});
	}
}
